import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Image from './_image.js'
import Button from './_button.js'
import Spinner from './_spinner.js'
import TextInput from './_text-input.js'
import FlexPaneSeparator from './_flex-pane-separator.js'

export default {
  name: 'FreeBetCode',
  values: {
    showCompactLayout: false,
    _mobile_showCompactLayout: true,
    labelContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'center',
          _desktop_padding: '0 8px 0 0',
          flexGrow: 0,
          flexShrink: 0,
        },
      },
    },
    label: {
      configSet: Text,
      configValues: {},
    },
    messageContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'flex-start',
        },
      },
    },
    error: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
          _desktop_flexBasis: '160px',
          _desktop_padding: '0 48px 0 0',
        },
      },
    },
    successContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          padding: '8px',
          flexGrow: 0,
          _desktop_flexBasis: '192px',
        },
      },
    },
    success: {
      configSet: Text,
      configValues: {},
    },
    successMessageIcon: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    button: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: 0,
            flexShrink: 0,
            flexBasis: '40px',
            minWidth: '40px',
          },
        },
      },
    },
    spinner: {
      configSet: Spinner,
      configValues: {
        style: {
          container: {
            flexBasis: '16px',
            flexShrink: 0,
            height: '40px',
          },
        },
      },
    },
    submitIcon: {
      configSet: Image,
      configValues: {
        src: 'plus',
        style: {
          flexBasis: '16px',
        },
      },
    },
    input: {
      configSet: TextInput,
      configValues: {
        style: {
          base: {
            padding: '8px',
            _desktop_flexGrow: 0,
            flexShrink: 0,
            flexBasis: '240px',
            minWidth: '0px',
          },
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          alignItems: 'stretch',
          flexGrow: 0,
          padding: '0px 16px 8px 8px',
          _mobile_padding: '8px',
        },
        separator: {
          style: {
            size: '4px',
          },
        },
      },
    },
    contentContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexBasis: '40px',
          justifyContent: 'flex-end',
        },
      },
    },
    labelAndInputSeparator: {
      configSet: FlexPaneSeparator,
      configValues: {
        style: {
          size: '4px',
        },
      },
    },
    inputAndButtonSeparator: {
      configSet: FlexPaneSeparator,
      configValues: {
        style: {
          size: '8px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
